import { setUser as setSentryUser } from '@sentry/browser'

import {
  GtmAPI,
  handleFlagsmithUser,
} from '@termly-web/common'

import { pushImpactUttTracking } from 'utils/impactTracking'


export default function handleAuthComplete({ user }) {
  handleFlagsmithUser(user)
  setSentryUser(user)
  pushImpactUttTracking(user)

  // This is important...if we don't do this, we'll start
  // hemorrhaging money from Google AdWords.
  GtmAPI.push({
    event: 'GET_USER_INFO_SUCCESS',
    payload: user,
  })
}
